import './Button.css'
import { Link } from 'react-router-dom'

export default function Button({size, text, color, route, onClick=()=>{}}) {
  return (
    <Link to={route} onClick={onClick} className={`btn ${color && ' btn'+color} ${size && ' btn'+size}`}>
        <p className='articleText'>{text}</p>
    </Link>
  )
}